var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 68,
  height: 32,
  viewBox: "0 0 68 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "i71y784vta",
  width: "158.3%",
  height: "158.3%",
  x: "-29.2%",
  y: "-20.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
})), /*#__PURE__*/React.createElement("rect", {
  id: "dkpnwznt6b",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  rx: 1
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#177991",
  d: "M23 12h39"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 12,
  r: 1.5,
  fill: "#177991",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dkpnwznt6b",
  fill: "#000",
  filter: "url(#i71y784vta)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dkpnwznt6b",
  className: "slider-thumb-center"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#177991"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m1.495 0-.001 1.149h2.702V0h.35v1.149h2.701V0h.35v1.149h2.701V0h.35v1.149h2.701V0h.35v1.149H16.4V0h.35v1.149h2.701V0h.35v1.149h2.698L22.5 0h.355v1.149L24 1.15v.35l-1.145-.001v2.7L24 4.2v.35l-1.145-.001V7.25H24v.35h-1.145v2.7H24v.35h-1.145v2.7H24v.35h-1.145v2.7H24v.35h-1.145v2.7H24v.35h-1.145v2.7H24v.35l-1.145-.001V24h-.35l-.001-1.151h-2.703V24h-.35v-1.151H16.75V24h-.35v-1.151h-2.701V24h-.35v-1.151h-2.701V24h-.35v-1.151H7.597V24h-.35v-1.151H4.546V24h-.35v-1.151H1.494L1.495 24h-.35l-.001-1.151L0 22.85v-.35h1.144v-2.7H0v-.35h1.144v-2.7H0v-.35h1.144v-2.7H0v-.35h1.144v-2.7H0v-.35h1.144V7.6H0v-.35h1.144v-2.7H0V4.2h1.144V1.499L0 1.5v-.35l1.144-.001L1.145 0zm21.008 19.8h-2.702v2.7h2.703zm-3.052 0H16.75v2.7h2.701zm-3.051 0h-2.701v2.7H16.4zm-3.051 0h-2.701v2.7h2.701zm-9.153 0H1.494v2.7h2.702zm3.051 0H4.546v2.7h2.701zm3.051 0H7.597v2.7h2.701zm-6.102-3.05H1.494v2.7h2.702zM7.247 4.549H4.546v.555l-.35.35v-.905l-2.702.001v2.7h1.381v.016l-.206.206-.053.128H1.494v2.7h.628l.146.35h-.774v2.7h1.065l.281.35H1.494v2.7h2.702v-1.253l.35.234V16.4h1.736l.832.253.626-.126.149.223h-.292v2.7h2.701v-1.263l.35.175v1.088h2.701v-1.951l.145-.109.132.034.073-.035v2.061H16.4v-1.208l.35.297v.911h2.701v-2.259l.143-.285.069-1.638-.19-.472.275-.273.053-.131V16.4h2.701v-2.7h-2.414l.145-.35h2.268v-2.7h-1.196l.273-.35h.923L22.5 7.6h-.814l-.35-.35H22.5V4.549h-2.699V5.83h-.35V4.549H16.75V7.25h.215l-.25.221H15.59l-.11-.221h.92V4.549h-2.701v1.546h-.115l-.235-.038V4.549h-2.701v1.193l-.35-.022V4.549H7.597l-.001.814-.349-.131zM22.502 16.75h-2.701v2.7h2.702zm-15.255 0H4.546v2.7h2.701zM4.196 1.499H1.494V4.2l2.702-.001zm18.303 0h-2.698v2.7H22.5zm-15.252 0H4.546v2.7h2.701zm3.051 0H7.597v2.7h2.701zm3.051 0h-2.701v2.7h2.701zm3.051 0h-2.701v2.7H16.4zm3.051 0H16.75v2.7h2.701z",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 0a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm-.5 1.5h-21v21h21zM5.667 6.775l2.11.792L12 7.83l.528-.264.528.527h.791l-.528.528h1.848l-.792 1.056v.528h1.056v-.792l.527-.528.528.528.264.528.528-.528h.528l.527-.792.528-.264.264-.527h.792v.791l-.792.528.528.528v.528l-1.056.263v.528l-.528.792.264.792v.527l-1.055 1.056v.528l.528 1.32-.264.527h-.792l-.264-1.583h-.792l-.527-.264-.792.264-.264.527-1.055-.264L12 16.01v.792l-1.056-.528-.263-1.056h-.792l-.264.528-.528-.791-.264-.528h-.791l-1.32.264-.791-.792-.792-.528-1.056-1.32v-.79l.528-.529-.528-.527v-1.32l.792-.792V6.775z"
})))));
export default SvgMapSlider;